import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { g as getCommonClassNameDefault } from '../defaults.esm.js';
import './styles.css';


var styles = {
    "separator": "Separator-module_separator__XNXqa",
    "separatorLeft": "Separator-module_separatorLeft__mbngJ",
    "separatorRight": "Separator-module_separatorRight__-f81z"
};

const Separator = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId }, ref)=>{
    return /*#__PURE__*/ jsxs("div", {
        ref: ref,
        id: id,
        className: `${styles.separator} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: styles.separatorLeft
            }),
            /*#__PURE__*/ jsx("div", {
                className: styles.separatorRight
            })
        ]
    });
});
Separator.displayName = 'Separator';

export { Separator };
